import { theme } from '@branchjs/neo-components';
import React from 'react';
import ConflictIcon from '../../../../common/components/core/PureQueryBuilder/ConflictIcon';
import styles from './DimensionOption.styles';

type BlockedDimension = {
  dimensions: string[];
  blockedBy: string;
};

type OwnProps = {
  label: string;
  value: string;
  blockedDimensions?: BlockedDimension[];
  options: any[];
  relatedMetrics: string[];
};

const DimensionOption = (props: OwnProps) => {
  const blockedDimension = props.blockedDimensions?.find((dimension) => {
    return dimension.dimensions.includes(props.value);
  });

  let option: { label: string; value: string } | null = null;

  if (blockedDimension) {
    option = props.options.find((checkedOption) => {
      return checkedOption.value === blockedDimension.blockedBy;
    });
  }

  return (
    <div className="pure-query-builder-dimension-option Select__option" id={`dropdown-item-${props.value}`}>
      {props.label}{' '}
      {option ? (
        <div className={styles.iconWrapper}>
          <ConflictIcon
            relatedMetrics={props.relatedMetrics}
            color={theme.colors.warning.main}
            conflictingDimensionName={option.label}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DimensionOption;
